import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import React from 'react';

import './Button.css';
export default React.forwardRef(function Button(props, ref) {
  const {
    focusable,
    children,
    autoFocus,
    ...rest
  } = props || {};
  return (
    <button
      {...ex(['Button', { focusable }], rest)}
      {...{
        ref,
        ...(autoFocus ? { autoFocus } : {}),
      }}
    >
      <div>
        {children}
      </div>
    </button>
  );
});
